import { ReactElement } from "react";
import { DifficultyIndicator } from "components/DifficultyIndicator";
import { IconLabel } from "components/IconLabel";
import tourDistanceIcon from "public/icons/tour-distance.svg";
import tourDurationIcon from "public/icons/tour-duration.svg";
import arrowUpIcon from "public/icons/arrow-up.svg";
import arrowDownIcon from "public/icons/arrow-down.svg";
import { formatDuration, formatLength } from "lib/util";

export const CardMetaTour = ({
  item,
}: {
  item: Travelguide.Tour;
}): ReactElement => (
  <div className="flex flex-row justify-between">
    <div className="flex flex-col gap-y-4">
      <p>{item.category.name}</p>
      <ul>
        <IconLabel as="li" icon={tourDistanceIcon}>
          {formatLength(item.distance / 1000, "kilometer")}
        </IconLabel>
        <IconLabel as="li" icon={tourDurationIcon}>
          {formatDuration(item.duration)}
        </IconLabel>
      </ul>
    </div>
    <div className="flex flex-col gap-y-4 items-end">
      {item.rating.difficulty ? (
        <IconLabel
          icon={<DifficultyIndicator difficulty={item.rating.difficulty} />}
        >
          {["leicht", "mittel", "schwer"][item.rating.difficulty - 1]}
        </IconLabel>
      ) : (
        <p>&nbsp;</p>
      )}
      <ul>
        <IconLabel as="li" icon={arrowUpIcon}>
          {formatLength(item.elevation.ascent, "meter")}
        </IconLabel>
        <IconLabel as="li" icon={arrowDownIcon}>
          {formatLength(item.elevation.descent, "meter")}
        </IconLabel>
      </ul>
    </div>
  </div>
);
